module.exports = __webpack_public_path__ + "components/flag/static/square/ax-ea86f0eea092356872bbc1cd21c41ec3.svg";